import React from "react";
import { useLocation } from "react-router-dom";
import Reveal from "@/components/sections/Reveal";
import ContactForm from "@/components/forms/ContactForm";
import { SITE } from "@/constants/site";

export default function Contact() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialSubject = params.get("subject") || undefined;

  return (
    <div>
      {/* HERO */}
      <section
        className="rk-section"
        style={{ paddingTop: "calc(var(--rk-section-py) + 60px)" }}
      >
        <div className="rk-container-text">
          <Reveal>
            <div className="rk-eyebrow">Contact</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="rk-heading-page mt-5">Start here.</h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 rk-body" style={{ color: "var(--rk-ink)" }}>
              Use this form for speaking, press, partnership, and advisory
              inquiries. Rakia reviews all messages personally. You will hear
              back within 3 business days. If you are reaching out about a
              fractional engagement, the Advisory page will help you frame your
              situation before we speak.
            </p>
          </Reveal>
        </div>
      </section>

      {/* FORM */}
      <section
        className="rk-section"
        style={{ backgroundColor: "var(--rk-surface)" }}
      >
        <div className="rk-container-text">
          <div
            className="p-6 md:p-10"
            style={{
              backgroundColor: "var(--rk-bg)",
              border: "1px solid var(--rk-copper)",
              borderRadius: 2,
            }}
          >
            <ContactForm initialSubject={initialSubject} />
          </div>
        </div>
      </section>

      {/* DIRECT */}
      <section className="rk-section-tight">
        <div className="rk-container-text">
          <div
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
            style={{ borderTop: "1px solid var(--rk-copper)", paddingTop: 36 }}
          >
            <div>
              <div className="rk-eyebrow">Response</div>
              <p
                className="mt-4"
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "clamp(22px, 2.2vw, 30px)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.01em",
                }}
              >
                Within 3 business days.
              </p>
            </div>
            <div>
              <div className="rk-eyebrow">Based</div>
              <p
                className="mt-4"
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "clamp(22px, 2.2vw, 30px)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.01em",
                }}
              >
                {SITE.location}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
